import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { loginSlice } from "./login/loginSlice";
import { tenantDetailSlice } from "./tenantDetail/tenantDetailSlice";
import { deleteTenantSlice } from "./deleteTenant/deleteTenantSlice";
import { createUserSlice } from "./createUser/createUserSlice";
import { userDetailSlice } from "./userDetail/userDetailSlice";
import { impersonateDetailSlice } from "./impersonateDetail/impersonateDetailSlice";
import {
  featureDetailSlice,
  featureListByTenant,
} from "./featuresDetails/featureDetailsSlice";
import { promptSlice } from "./promptDetails/promptDetailsSlice";
import {
  systemPromptSlice,
  systemPromptTypeSlice,
} from "./systemPromptDetails/systemPromptDetailsSlice";

const appReducer = combineReducers({
  login: loginSlice.reducer,
  tenantDetail: tenantDetailSlice.reducer,
  featureDetails: featureDetailSlice.reducer,
  featureListByTenant: featureListByTenant.reducer,
  deleteTenant: deleteTenantSlice.reducer,
  createUser: createUserSlice.reducer,
  userDetail: userDetailSlice.reducer,
  impersonateDetail: impersonateDetailSlice.reducer,
  promptDetail: promptSlice.reducer,
  systemPromptTypeDetail: systemPromptTypeSlice.reducer,
  systemPromptDetail: systemPromptSlice.reducer,
});

const store = configureStore({
  reducer: appReducer,
});

export default store;
